import { c as _c } from "react/compiler-runtime";
import { TabsWithRoutes } from "@components/common/tabs/tabs-with-routes";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { MembersPage } from "@pages/members/members-page";
import { Teams } from "@pages/members/teams/teams";
import { NotFoundPage } from "@pages/not-found-page";
import { UsersTabs } from "@router/route-params";
import { useAppParams } from "@router/router-helper";
import { useCompanyId } from "@context-providers/company-id-provider";
import { TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
import { selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { RequiredRoleCompanyLevelName } from "@utils/access-control/company/company-access-control-types";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { OpenTabEvents } from "@utils/track-event/track-event-list";

/** Content that will have the logic for the users tabs */
export function MembersWorkspace() {
  const $ = _c(13);
  const {
    usersTab
  } = useAppParams();
  const companyId = useCompanyId();
  const {
    canViewTeams
  } = useHasUserValidRoleCompanyLevel();
  const selectedSdbCompany = useAppSelector(selectedSdbCompanySelector);
  if (!usersTab || !Object.values(UsersTabs).includes(usersTab)) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <NotFoundPage />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      label: "Members",
      route: UsersTabs.members,
      content: _temp,
      loadingContent: <div />
    };
    t1 = capitalizeFirstLetter(TEAMS_DISPLAY_NAME);
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== companyId) {
    t2 = () => <Teams companyId={companyId} />;
    $[3] = companyId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = !canViewTeams;
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = [t0, {
      label: t1,
      route: UsersTabs.teams,
      content: t2,
      loadingContent: t3,
      requiredRoleCompanyLevel: RequiredRoleCompanyLevelName.canViewTeams,
      isHidden: t4
    }];
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const usersTabs = t5;
  let t6;
  if ($[9] !== selectedSdbCompany || $[10] !== usersTab || $[11] !== usersTabs) {
    t6 = <TabsWithRoutes dataTestId="USER_CONTAINER" selectedTab={usersTab} requiredAttribute={selectedSdbCompany} trackingEventPageName={OpenTabEvents.openWorkspaceUsersTab} tabs={usersTabs} />;
    $[9] = selectedSdbCompany;
    $[10] = usersTab;
    $[11] = usersTabs;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function _temp() {
  return <MembersPage />;
}